import React, { Component } from "react";
import { Navigate } from "react-router-dom";
//AuthenticationInner pages

import Cover404 from '../pages/AuthenticationInner/Errors/Cover404';
import Alt404 from '../pages/AuthenticationInner/Errors/Alt404';
import Error500 from '../pages/AuthenticationInner/Errors/Error500';
import Offlinepage from "../pages/AuthenticationInner/Errors/Offlinepage";
//login
import Login from "../pages/Authentication/Login";
import ForgetPasswordPage from "../pages/Authentication/ForgetPassword";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import ConfirmSignUp from '../pages/Authentication/ConfirmSignUp';
import ConfirmResetPass from "../pages/Authentication/ConfirmResetPass";
import VideoLibrary from "../pages/VideoLibrary/videoLibrary";
// User Profile
import UserProfile from "../pages/Authentication/user-profile";
import ChangePassword from "../pages/AuthenticationInner/PasswordCreate/ChangePassword";
import CurrentPlan from "../pages/Billing/currentPlan";
import PaymentMethod from "../pages/Billing/paymentMethod";
import BillingDetails from "../pages/Billing/billingDetails";
import Invoices from "../pages/Billing/invoices";
import BillingAlerts from "../pages/Billing/billingAlert";
import BillingAddress from "../pages/Billing/billingAddress";
import Plans from "../pages/Billing/plans";
import VideoProcessor from "../pages/VideoProcessor/VideoProcessor";
import VideoDetails from "../pages/VideoProcessor/VideoDetails";
import VideoSettingTrans from "../pages/VideoProcessor/VideoSettingTrans";
import VideoSettingSingle from "../pages/VideoProcessor/VideoSettingSingle";
import Summary from "../pages/VideoProcessor/Summary";


const authProtectedRoutes = [

  //User Profile
  { path: "/profile", component: <UserProfile /> },

  {
    path: "/",
    exact: true,
    component: <Navigate to="/dam" />,
  },
  { path: "*", component: <Navigate to="/dashboard" /> },
  { path: "/change-password", component: <ChangePassword /> },
  { path: "/dam", component: <VideoLibrary /> },
  { path: "/billing/current-plan", component: <CurrentPlan /> },
  { path: "/billing/payment-method", component: <PaymentMethod /> },
  { path: "/billing/billing-details", component:<BillingDetails/>},
  { path: "/billing/invoices", component: <Invoices/>},
  { path: "/billing/billing-alert", component: <BillingAlerts/>},
  { path: "/billing/billing-address", component: <BillingAddress/>},
  { path: "/billing/plans", component: <Plans/>},
  { path: "/video-processor", component: <VideoProcessor /> },
  { path: "/video-processor/video-detail/:id", component: <VideoDetails /> },
  { path: "/video-processor/video-setting-trans", component: <VideoSettingTrans /> },
  { path: "/video-processor/video-setting-single", component: <VideoSettingSingle /> },
  { path: "/video-processor/video-setting-trans/summary", component: <Summary /> },
];

const publicRoutes = [

  // Authentication Page
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPasswordPage /> },
  { path: "/register", component: <Register /> },
  { path: "/confirm-email", component: <ConfirmSignUp /> },
  { path: "/confirm-reset-password", component: <ConfirmResetPass /> },
  { path: "/404", component: <Cover404 /> },
  { path: "/404-alt", component: <Alt404 /> },
  { path: "/500", component: <Error500 /> },
  { path: "/offline", component: <Offlinepage /> },

];

export { authProtectedRoutes, publicRoutes };